export function normalizePeopleSelectionId(
  value: string | null | undefined,
): string | undefined {
  const trimmedValue = value?.trim();
  return trimmedValue ? trimmedValue.toLowerCase() : undefined;
}

export function normalizePeopleSelection(
  values: readonly (string | null | undefined)[],
): string[] {
  const normalizedValues = new Set<string>();

  for (const value of values) {
    const normalizedValue = normalizePeopleSelectionId(value);
    if (normalizedValue) {
      normalizedValues.add(normalizedValue);
    }
  }

  return [...normalizedValues];
}

export function arePeopleSelectionsEqual(
  left: readonly (string | null | undefined)[],
  right: readonly (string | null | undefined)[],
): boolean {
  const normalizedLeft = normalizePeopleSelection(left);
  const normalizedRight = normalizePeopleSelection(right);

  return (
    normalizedLeft.length === normalizedRight.length &&
    normalizedLeft.every((id) => normalizedRight.includes(id))
  );
}
